/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const GetLanguages = {
  id: 'languages.get',
  tag: 'Common',
  summary: 'Get languages',
  description: 'Retrieve all languages',
  method: 'get',
  route: () => '/language',
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(z.strictObject({ code: z.enum(['en', 'de']) })),
        },
      },
    },
  },
} as const satisfies Endpoint;
